import { atom } from 'recoil';
import { GroupSettings } from '../types/common';

const groupSettingsLoadedState = atom<boolean>({
  key: 'groupSettings/settingsLoaded',
  default: false,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['groupSettings/settingsLoaded', newValue]);
    });
  }],
});

const groupSettingsState = atom<GroupSettings | null>({
  key: 'groupSettings/settings',
  default: null,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['groupSettings/settings', newValue]);
    });
  }],
});

export {
  groupSettingsLoadedState,
  groupSettingsState
};